import { render, staticRenderFns } from "./DecisionNodeEditor.vue?vue&type=template&id=1b47363b&scoped=true&"
import script from "./DecisionNodeEditor.vue?vue&type=script&lang=js&"
export * from "./DecisionNodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./DecisionNodeEditor.vue?vue&type=style&index=0&id=1b47363b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47363b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
